import React from 'react'
import Docs from './Submenus/Docs/index'
import Blogs from './Submenus/Blogs/index'
import Company from './Submenus/Company/index'
import Support from './Submenus/Support/index'
import UsingiCloudReady from './Submenus/UsingIcloudReady/index'
import LanguageSwitcher from './Submenus/LanguageSwitcher/index'
import ThemeSwitcher from './Submenus/ThemeSwitcher/index'
import Products from './Submenus/Products/index'
import Markets from './Submenus/Markets/index'

// removed from src/navs/index.json

// {
//     "title": "Docs",
//     "url": "/docs",
//     "sub": {
//         "component": "Docs"
//     }
// },
// {
//     "title": "Blogs",
//     "url": "/blogs",
//     "sub": {
//         "component": "Blogs"
//     }
// },
// {
//     "title": "Support",
//     "url": "/support",
//     "sub": {
//         "component": "Support"
//     }
// },

const submenus = {
    Docs,
    // Blogs,
    Company,
    Support,
    UsingiCloudReady,
    LanguageSwitcher,
    ThemeSwitcher,
    Products,
    Markets,
}

export default function Submenu({ referenceElement, menuItem, component, open, parentURL }) {
    // const { component } = menu
    const variants = {
        hidden: { height: 0 },
        shown: { height: 'auto' },
    }
    return submenus[component]({ referenceElement, menuItem })
}
